import { render } from "./ServicesSlick.vue?vue&type=template&id=7088ba03"
import script from "./ServicesSlick.vue?vue&type=script&lang=js"
export * from "./ServicesSlick.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/ServicesSlick.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7088ba03"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7088ba03', __exports__)) {
    api.reload('7088ba03', __exports__)
  }
  
  module.hot.accept("./ServicesSlick.vue?vue&type=template&id=7088ba03", () => {
    api.rerender('7088ba03', render)
  })

}


export default __exports__